//
export const DEFAULT_LOCALE = 'en-GB';

// Question types
export const QUESTION_TYPE_SMILEYQUINTET = 'smiley-quintet';
export const QUESTION_TYPE_SMILEYQUARTET = 'smiley-quartet';
export const QUESTION_TYPE_AGREE = 'agree';
export const QUESTION_TYPE_YESNO = 'yes-no';
export const QUESTION_TYPE_NPS = 'nps';
export const QUESTION_TYPE_MULTIPLECHOICE = 'multiple-choice';
export const QUESTION_TYPE_SELECTMANY = 'select-many';
export const QUESTION_TYPE_COMMENT = 'comment';
export const QUESTION_TYPE_SHORTTEXT = 'short-text';
export const QUESTION_TYPE_TYPEAHEAD = 'typeahead';
export const QUESTION_TYPE_NUMBER = 'number';
export const QUESTION_TYPE_EMAIL = 'email';
export const QUESTION_TYPE_SMILEYCOMMENT = 'smiley-comment';
export const QUESTION_TYPE_FIVESTARS = 'five-stars';
export const QUESTION_TYPE_PICTURES = 'pictures';
export const QUESTION_TYPE_PICTURES_MULTIPLE = 'pictures-multiple';



// WEBPACK FOOTER //
// ./src/constants.js